import { Component, Input, ViewChild } from '@angular/core';
import { AuthService } from '@app/services/auth.service';
import { ShowView } from '@common/views';
import { TrainingProgramRecord } from '@models/training/training-program-record.model';
import { ActivatedRoute, Router } from '@angular/router';
import { DeprecatedModalFormComponent } from '@app/components';
import { FileHelperService } from '@app/services';
import { TrainingProgram } from '@models/training/training-program.model';
import { DeleteRecordModal, TrainingRecordReminderForm } from '@forms/employees/components';
import { Location } from '@angular/common';
import { TrainingResolver } from '@training/training.resolver';
import { Translatable } from '@app/types/translatable.type';
@Component({
    templateUrl: './record-show.template.html',
    styleUrls: ['./record-show.style.scss'],
})
export class RecordShowView extends ShowView {
    @ViewChild('deleteRecordModal') deleteRecord: DeleteRecordModal;
    @ViewChild('sendReminderForm') sendReminder: TrainingRecordReminderForm;
    @ViewChild('trainingRecordFormModal') trainingRecordFormModal: DeprecatedModalFormComponent;
    @Input() record: TrainingProgramRecord = null;

    isLoading = true;
    protected records: TrainingProgramRecord[] = [];
    protected completedTotal: number | null = null;

    constructor(
        public fileHelper: FileHelperService,
        public auth: AuthService,
        public location: Location,
        private route: ActivatedRoute,
        private router: Router,
        private resolver: TrainingResolver
    ) {
        super();
        this.record = this.route.snapshot.data.models.get('trainingProgramRecord');
        TrainingProgramRecord.query()
            .where('training_program_id', this.record.trainingProgram.id)
            .where('employee_id', this.auth.employee.id)
            .all()
            .then(([records]) => {
                this.records = records;
                this.completedTotal = this.records.filter((r: TrainingProgramRecord): boolean => r.isComplete).length;
                this.isLoading = false;
            });
    }

    reResolve(): void {
        this.isLoading = true;
        this.resolver
            .resolve(this.route.snapshot, this.router.routerState.snapshot)
            .then((models) => {
                this.record = <TrainingProgramRecord>models.get('trainingProgramRecord');
                this.isLoading = false;
            })
            .catch((err) => err.message || 'Unable to reload record');
    }

    onSave(): void {
        this.reResolve();
        this.trainingRecordFormModal.hide();
    }

    getModelFormTitle(): Translatable {
        const key = this.record.isComplete ? 'training.formTitleEdit' : 'training.formTitleComplete';
        return {
            key,
            params: { name: this.record.trainingProgram.name },
        };
    }

    getStatusMessage(): Translatable | null {
        if (this.record.isComplete) {
            return null;
        }

        if (!this.canEdit()) {
            return 'training.pending';
        }

        const isInProgress =
            this.record.trainingProgram.maxOccurrences > 1 &&
            this.completedTotal < this.record.trainingProgram.maxOccurrences;

        if (!isInProgress) {
            return null;
        }

        return {
            key: 'training.sessionsCompleted',
            params: {
                completed: this.completedTotal,
                max: this.record.trainingProgram.maxOccurrences,
            },
        };
    }

    isAdmin(): boolean {
        return this.auth.can(TrainingProgram.managePermission);
    }

    canEdit(): boolean {
        return (
            this.auth.can(TrainingProgram.managePermission) ||
            (this.record.isEmployeeSubmittable && this.auth.isSelf(this.record.employee)) ||
            this.auth.supervises(this.record.employee)
        );
    }

    onCancel(): void {}

    onDelete(): void {}
}
